<div class="cipx-form-container w-full bg-gray-100 dark:bg-transparent flex flex-col h-full">
  <!-- Header with Breadcrumbs and View Switcher -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center sm:justify-between p-6 sm:py-8 md:px-8 border-b bg-card dark:bg-transparent">
    <div>
      <div class="flex items-center mt-0.5 font-medium text-secondary">
   <!--     <ng-container *ngIf="!path.length && currentFolder">
          {{ getFolders(currentFolder.data).length }} folders, {{ getFiles(currentFolder.data).length }} files
        </ng-container>-->
        <!-- Breadcrumbs -->
        <ng-container *ngIf="path.length">
          <div class="flex items-center space-x-2">
            <a class="text-primary cursor-pointer" (click)="navigateBack(-1)">Root</a>
            <div class="">/</div>
            <ng-container *ngFor="let p of path; let i = index; let last = last; trackBy: trackByFn">
              <ng-container *ngIf="!last">
                <a class="text-primary cursor-pointer" (click)="navigateBack(i)">{{ p.name }}</a>
              </ng-container>
              <ng-container *ngIf="last">
                <div>{{ p.name }}</div>
              </ng-container>
              <ng-container *ngIf="!last">
                <div class="">/</div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- View Switcher -->
    <div class="mt-4 sm:mt-0">
      <mat-button-toggle-group [value]="viewType" (change)="viewType = $event.value" appearance="standard">
        <mat-button-toggle value="tile">
          <mat-icon [svgIcon]="'heroicons_outline:view-grid'"></mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="tree">
          <mat-icon [svgIcon]="'heroicons_outline:view-list'"></mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <!-- Items list -->
  <cipx-scrollable-content class="flex-auto overflow-y-auto" *ngIf="currentFolder">
    <ng-container *ngIf="viewType === 'tile'">
      <ng-container
        *ngIf="getFolders(currentFolder.data).length > 0 || getFiles(currentFolder.data).length > 0; else noItems">
        <div class="p-6 md:p-8 space-y-8">
          <!-- Folders -->
          <ng-container *ngIf="getFolders(currentFolder.data).length > 0">
            <div>
              <div class="font-medium">Folders</div>
              <div class="flex flex-wrap -m-2 mt-2">
                <ng-container *ngFor="let folder of getFolders(currentFolder.data); trackBy: trackByFn">
                  <div class="relative w-40 h-40 m-2 p-4 shadow rounded-2xl bg-card">
                    <a class="z-10 absolute inset-0 flex flex-col p-4 cursor-pointer" (click)="navigateToFolder(folder)">
                      <div class="aspect-[9/6]">
                        <div class="flex items-center justify-center h-full">
                          <!-- Icon -->
                          <mat-icon
                            class="icon-size-14 text-hint opacity-50"
                            [svgIcon]="'heroicons_solid:folder'"></mat-icon>
                        </div>
                      </div>
                      <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                        <div class="truncate" [matTooltip]="folder.label">{{ folder.label }}</div>
                        <ng-container *ngIf="folder.files || folder.subfolders">
                          <div class="text-secondary truncate">
                            {{ (folder.files?.length || 0) + (folder.subfolders?.length || 0) }} items
                          </div>
                        </ng-container>
                      </div>
                    </a>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- Files -->
          <ng-container *ngIf="getFiles(currentFolder.data).length > 0">
            <div>
              <div class="font-medium">Files</div>
              <div class="flex flex-wrap -m-2 mt-2">
                <ng-container *ngFor="let file of getFiles(currentFolder.data); trackBy: trackByFn">
                  <div class="relative w-40 h-40 m-2 p-4 shadow rounded-2xl bg-card group">
                    <button
                      [color]="'primary'"
                      class="absolute z-20 top-1.5 right-1.5 w-8 h-8 min-h-8 opacity-0 group-hover:opacity-100 transition-opacity"
                      (click)="$event.preventDefault(); $event.stopPropagation(); downloadFile(file)"
                      mat-icon-button>
                      <mat-icon>download</mat-icon>
                    </button>
                    <a class="z-10 absolute inset-0 flex flex-col p-4 cursor-pointer" (click)="viewFile(file)">
                      <div class="aspect-[9/6]">
                        <div class="flex items-center justify-center h-full">
                          <!-- Icons -->
                          <div class="relative">
                            <mat-icon
                              class="icon-size-14 text-hint opacity-50"
                              [svgIcon]="'heroicons_solid:document'"></mat-icon>
                            <div
                              class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                              [class.bg-red-600]="['PDF', 'HTML'].includes(file.file_extension?.toUpperCase())"
                              [class.bg-blue-600]="['DOC', 'DOCX'].includes(file.file_extension?.toUpperCase())"
                              [class.bg-green-600]="['XLS', 'XLSX'].includes(file.file_extension?.toUpperCase())"
                              [class.bg-gray-600]="file.file_extension?.toUpperCase() === 'TXT'"
                              [class.bg-amber-600]="
                                ['JPG', 'JPEG', 'PNG', 'GIF'].includes(file.file_extension?.toUpperCase())
                              ">
                              {{ file.file_extension?.toUpperCase() || 'FILE' }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                        <div class="truncate" [matTooltip]="file.file_friendly_name || file.file_name">
                          {{ file.file_friendly_name || file.file_name }}
                        </div>
                        <div class="text-secondary truncate">{{ file.file_size | number }} bytes</div>
                      </div>
                    </a>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="viewType === 'tree'">
      <div class="p-4">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
          <!-- This is the tree node template for leaf nodes -->
          <mat-tree-node *matTreeNodeDef="let node">
            <li class="mat-tree-node list-none">
              <!-- use a disabled button to provide padding for tree leaf -->
              <button mat-icon-button disabled></button>
              <div
                class="flex items-center cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 px-2 py-1 rounded group w-full"
                *ngIf="!isFolder(node)"
                (click)="viewFile(node)">
                <mat-icon class="icon-size-5 mr-2 text-hint" [svgIcon]="'heroicons_solid:document'"></mat-icon>
                <span class="text-sm truncate mr-2">{{ node.file_friendly_name || node.file_name }}</span>
                <span class="text-xs text-secondary mr-2">{{ node.file_size | number }} bytes</span>
                <button
                  mat-icon-button
                  [color]="'primary'"
                  class="ml-auto opacity-0 group-hover:opacity-100 transition-opacity"
                  (click)="$event.stopPropagation(); downloadFile(node)"
                  matTooltip="Download">
                  <mat-icon>download</mat-icon>
                </button>
              </div>
              <div class="flex items-center px-2 py-1" *ngIf="isFolder(node)">
                <mat-icon class="icon-size-5 mr-2 text-hint" [svgIcon]="'heroicons_solid:folder'"></mat-icon>
                <span class="text-sm font-medium">{{ node.label }}</span>
              </div>
            </li>
          </mat-tree-node>
          <!-- This is the tree node template for expandable nodes -->
          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <li class="list-none">
              <div class="mat-tree-node">
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.label">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                </button>
                <div class="flex items-center">
                  <mat-icon class="icon-size-5 mr-2 text-hint" [svgIcon]="'heroicons_solid:folder'"></mat-icon>
                  <span class="text-sm font-medium">{{ node.label }}</span>
                </div>
              </div>
              <ul [class.hidden]="!treeControl.isExpanded(node)" class="pl-8">
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      </div>
    </ng-container>

    <!-- No items template -->
    <ng-template #noItems>
      <div class="flex flex-auto flex-col items-center justify-center bg-gray-100 dark:bg-transparent min-h-[400px]">
        <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
        <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">There are no items!</div>
      </div>
    </ng-template>
  </cipx-scrollable-content>
</div>
